import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Table,
  Tag,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { Link as LinkStyle } from "@chakra-ui/react";
import React from "react";
import { MdAdd } from "react-icons/md";
import { Link, useHistory } from "react-router-dom";
import { Title } from "../../components/Title";
import { TierForm } from "../../forms";
import { ICreateTierValues } from "../../forms/TierForm";
import {
  HealthInsuranceCardType,
  TiersDocument,
  useCreateTierMutation,
  useTiersQuery,
} from "../../graphql";

const TierList: React.FC = () => {
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { data: tiersData, loading: loadingTiers } = useTiersQuery();
  const [createTier, { data, loading }] = useCreateTierMutation();

  const handleCreateTierEvent = async (tier: ICreateTierValues) => {
    const { data: newTier } = await createTier({
      variables: {
        activeDays: parseInt(tier.activeDays),
        color: tier.color,
        default: tier.default === "1",
        demo: tier.demo === "1",
        descriptionEn: tier.description.en,
        descriptionSq: tier.description.sq,
        descriptionMk: tier.description.mk,
        nameEn: tier.name.en,
        nameSq: tier.name.sq,
        nameMk: tier.name.mk,
        eventsPerMonth: parseInt(tier.eventsPerMonth),
        pricePerYear: parseFloat(tier.pricePerYear),
        benefitIDs: tier.benefitIDs,
        sigalHealthInsuranceType: tier.sigalHealthInsuranceType,
      },
      refetchQueries: [
        {
          query: TiersDocument,
        },
      ],
    });

    // newTier.createTier.id
    onClose();
  };

  return (
    <>
      <Modal
        closeOnOverlayClick={false}
        isOpen={isOpen}
        onClose={onClose}
        size="xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Shto një paketë</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <TierForm onSubmit={(tier) => handleCreateTierEvent(tier)} />
          </ModalBody>
        </ModalContent>
      </Modal>
      <Box borderWidth="1px" borderRadius="lg" background="#FFF" p="10px">
        <Title title="Lista e paketave">
          <Button
            rightIcon={<MdAdd />}
            colorScheme="blue"
            variant="outline"
            size="sm"
            onClick={onOpen}
          >
            Shto paketë
          </Button>
        </Title>

        <Alert status="info" marginBottom={4}>
          <AlertIcon />
          <Text>
            Në listën e paketave duhet të ketë detyrimisht një paketë me
            atributin{" "}
            <Tag
              size="sm"
              borderRadius="full"
              variant="solid"
              colorScheme="blue"
            >
              klientë me policë
            </Tag>{" "}
            , një paketë me atributin{" "}
            <Tag
              size="sm"
              borderRadius="full"
              variant="solid"
              colorScheme="blue"
            >
              demo
            </Tag>{" "}
            dhe së paku një paketë{" "}
            <Tag
              size="sm"
              borderRadius="full"
              variant="solid"
              colorScheme="green"
            >
              publike
            </Tag>
            . Nëse mungon ky konfigurim do të ketë probleme me abonimin dhe
            rregjistrimin e klientëve. Nëse dëshironi të jeni më specifikë në
            zgjedhjen e paketës në varësi të llojit të policës mund të përdorni
            atributet{" "}
            <Tag
              size="sm"
              borderRadius="full"
              variant="solid"
              colorScheme="gray"
            >
              silver
            </Tag>
            {", "}
            <Tag
              size="sm"
              borderRadius="full"
              variant="solid"
              colorScheme="orange"
            >
              gold
            </Tag>
            {" ose "}
            <Tag
              size="sm"
              borderRadius="full"
              variant="solid"
              colorScheme="blackAlpha"
            >
              standard
            </Tag>
            .
          </Text>
        </Alert>

        <Table variant="striped" size="sm">
          <Thead>
            <Tr>
              <Th>Titulli</Th>
              <Th>Nr. eventeve</Th>
              <Th>Kohëzgjatja</Th>
              <Th isNumeric>Çmimi</Th>
              <Th isNumeric>Publikuar</Th>
              <Th isNumeric>Atributi</Th>
            </Tr>
          </Thead>
          <Tbody>
            {tiersData?.tiers?.map((tier) => (
              <Tr key={tier.id}>
                <Td width="300px">
                  <Link to={`/tier/${tier.id}`}>
                    <LinkStyle>{tier.name}</LinkStyle>
                  </Link>
                </Td>
                <Td>{tier.eventsPerMonth} evente/muaj</Td>

                <Td>{tier.activeDays} ditë</Td>
                <Td isNumeric>{tier.pricePerYear} lekë</Td>
                <Td isNumeric>
                  {tier.isPublic ? (
                    <Tag
                      size="sm"
                      borderRadius="full"
                      variant="solid"
                      colorScheme="green"
                    >
                      publike
                    </Tag>
                  ) : (
                    <Tag
                      size="sm"
                      borderRadius="full"
                      variant="solid"
                      colorScheme="red"
                    >
                      e pa publikuar
                    </Tag>
                  )}
                </Td>
                <Td isNumeric>
                  {tier.isDefaultForSigalClients ? (
                    <Tag
                      size="sm"
                      borderRadius="full"
                      variant="solid"
                      colorScheme="blue"
                    >
                      klientë me policë
                    </Tag>
                  ) : (
                    ""
                  )}
                  {tier.isDefaultForDemo ? (
                    <Tag
                      size="sm"
                      borderRadius="full"
                      variant="solid"
                      colorScheme="blue"
                    >
                      demo
                    </Tag>
                  ) : (
                    ""
                  )}
                  {tier.sigalHealthInsuranceType ===
                  HealthInsuranceCardType.Silver ? (
                    <Tag
                      size="sm"
                      borderRadius="full"
                      variant="solid"
                      colorScheme="gray"
                    >
                      silver
                    </Tag>
                  ) : (
                    ""
                  )}

                  {tier.sigalHealthInsuranceType ===
                  HealthInsuranceCardType.Gold ? (
                    <Tag
                      size="sm"
                      borderRadius="full"
                      variant="solid"
                      colorScheme="orange"
                    >
                      gold
                    </Tag>
                  ) : (
                    ""
                  )}

                  {tier.sigalHealthInsuranceType ===
                  HealthInsuranceCardType.Standard ? (
                    <Tag
                      size="sm"
                      borderRadius="full"
                      variant="solid"
                      colorScheme="blackAlpha"
                    >
                      standard
                    </Tag>
                  ) : (
                    ""
                  )}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </>
  );
};

export default TierList;
